import React, { type ReactElement } from 'react';

export const EmptyInboxIcon = (): ReactElement => (
  <svg
    width="141"
    height="120"
    viewBox="0 0 141 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Profile icon</title>
    <g clipPath="url(#clip0_125_3563)">
      <path
        d="M37.5 101.776C37.5 111.237 45.2 118.905 54.7 118.905H123.8C133.3 118.905 141 111.237 141 101.776V59.2531C141 49.7926 133.3 42.1245 123.8 42.1245H54.7C45.3 42.1245 37.5 49.7926 37.5 59.2531V101.776Z"
        fill="#EAF0FA"
      />
      <path
        d="M90.6999 90.025C90.6999 95.4026 86.3 99.7844 80.9 99.7844H62C56.6 99.7844 52.2 95.4026 52.2 90.025V71.303C52.2 65.9254 56.6 61.5437 62 61.5437H80.8C86.2 61.5437 90.5999 65.9254 90.5999 71.303V90.025H90.6999Z"
        fill="white"
      />
      <path
        d="M71.3999 71.9005C74.2999 71.9005 76.6999 74.2905 76.6999 77.1785C76.6999 80.2656 73.8999 83.6515 71.3999 83.6515C68.8999 83.6515 66.0999 80.2656 66.0999 77.1785C66.0999 74.2905 68.4999 71.9005 71.3999 71.9005ZM71.3999 70.2075C67.5999 70.2075 64.3999 73.2947 64.3999 77.1785C64.3999 80.9627 67.7999 85.2449 71.3999 85.2449C74.8999 85.2449 78.3999 80.9627 78.3999 77.1785C78.3999 73.3942 75.2999 70.2075 71.3999 70.2075Z"
        fill="#031D44"
      />
      <path
        d="M84.9 98.3901C84.6 94.4067 82.2 91.1204 79.1 90.4233C76.7 89.8258 73.9 89.4275 71.5 89.4275C69 89.4275 66.3 89.9254 63.9 90.4233C60.5 91.22 58 94.9047 58 99.2864V104.664"
        stroke="#031D44"
        strokeWidth="1.6603"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M101.5 77.1785H125.8"
        stroke="white"
        strokeWidth="2.4584"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M101.5 86.2407H115.9"
        stroke="white"
        strokeWidth="2.4584"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M59.1999 2.7884C64.6999 2.7884 69.1999 7.26973 69.1999 12.7469V41.4274C69.1999 46.9046 64.6999 51.3859 59.1999 51.3859H12.4999C6.9999 51.3859 2.4999 46.9046 2.4999 41.4274V12.6473C2.4999 7.17015 6.9999 2.68882 12.4999 2.68882H59.1999V2.7884ZM59.1999 1.09546H12.4999C6.0999 1.09546 0.899902 6.27388 0.899902 12.6473V41.3278C0.899902 47.7013 6.0999 52.8797 12.4999 52.8797H59.0999C65.4999 52.8797 70.6999 47.7013 70.6999 41.3278V12.6473C70.7999 6.27388 65.4999 1.09546 59.1999 1.09546Z"
        fill="#031D44"
      />
      <path
        d="M36.7999 33.4606C36.7999 37.1453 33.7999 40.0333 30.1999 40.0333H17.4999C13.7999 40.0333 10.8999 37.0457 10.8999 33.4606V20.8133C10.8999 17.1287 13.8999 14.2407 17.4999 14.2407H30.1999C33.8999 14.2407 36.7999 17.2283 36.7999 20.8133V33.4606Z"
        fill="#EAF0FA"
      />
      <path
        d="M28.4999 24.7967C28.4999 27.3859 26.1999 30.2739 23.7999 30.2739C21.3999 30.2739 19.0999 27.3859 19.0999 24.7967C19.0999 22.2075 21.1999 20.1162 23.7999 20.1162C26.3999 20.1162 28.4999 22.2075 28.4999 24.7967Z"
        stroke="#031D44"
        strokeWidth="1.9358"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M32.8998 39.1369C32.6998 36.4481 31.0998 34.2573 28.9998 33.7594C27.3998 33.361 25.4998 33.0623 23.8998 33.0623C22.1998 33.0623 20.3998 33.361 18.7998 33.7594C16.4998 34.2573 14.7998 36.8465 14.7998 39.7345V43.4191"
        stroke="#031D44"
        strokeWidth="1.9358"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M44.0999 24.697H60.4999"
        stroke="#031D44"
        strokeWidth="1.6603"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M44.0999 30.8713H53.7999"
        stroke="#031D44"
        strokeWidth="1.6603"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_125_3563">
        <rect
          width="140"
          height="120"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
